import { FormattedMessage, useIntl } from 'react-intl';

import { CheckboxField } from '@/components/CheckboxField';
import { Col } from '@/components/Col';
import { Flex } from '@/components/Flex';
import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { Typography } from '@/components/Typography';
import { paths } from '@/lib/paths';
import { checkoutMessages } from '@/messages/checkout';
import { Header } from '@/views/ReviewView/components';

export const NflMarketingConsentCheckbox = ({
  disabled = false,
}: {
  disabled?: boolean;
}) => {
  const { formatMessage } = useIntl();

  return (
    <Col>
      <Flex flexDirection='column' gridGap={2}>
        <Header>
          {formatMessage(checkoutMessages.nflMarketingConsentTitle)}
        </Header>

        <CheckboxField
          data-testid='NflMarketingConsent'
          disabled={disabled}
          name='userAffiliated'
        >
          <Typography>
            <FormattedMessage
              defaultMessage={
                checkoutMessages.nflMarketingConsentMessage.defaultMessage
              }
              id={checkoutMessages.nflMarketingConsentMessage.id}
              values={{
                policyLink: (
                  <LinkWithLocale
                    aria-label='NFL marketing consent'
                    href={paths.privacyPolicy.url()}
                    target='_blank'
                  >
                    <FormattedMessage
                      {...checkoutMessages.nflMarketingConsentPolicy}
                    />
                  </LinkWithLocale>
                ),
              }}
            />
          </Typography>
        </CheckboxField>
      </Flex>
    </Col>
  );
};
